import App from './App.svelte';

const urlParams = new URLSearchParams(window.location.search);
const id = urlParams.get('id');

const app = new App({
	target: document.body,
	props: {
		id
	}
});

export default app;